export default function UseCasesSection() {
  const data = [
    {
      title: "Healthcare",
      highlight: "80% Less Manual Documentation Work",
      points: [
        "Extract patient details from medical reports and forms",
        "Automate insurance claim document processing",
        "Convert medical records into structured data",
        "Reduce administrative workload for healthcare staff",
      ],
    },
    {
      title: "Human Resources",
      highlight: "70% Faster HR Document Processing",
      points: [
        "Automatically process resumes and candidate applications",
        "Extract employee data from onboarding forms",
        "Organize employee records and HR documentation",
        "Simplify HR compliance and record management",
      ],
    },
    {
      title: "Procurement & Supply Chain",
      highlight: "4× Faster Document Handling",
      points: [
        "Extract data from invoices, purchase orders, and supplier documents",
        "Organize shipment and logistics documentation",
        "Improve supplier document management",
        "Accelerate procurement workflows",
      ],
    },
  ];

  return (
    <div className="w-full px-6 md:px-12 pt-16 md:pt-20 container-width">
      {/* Heading */}
      <div className="max-w-6xl mx-auto mb-12 text-center md:text-left">
        {/* <p className="text-xs text-gray-500 uppercase mb-2">Section - 4</p> */}
        <h2 className="text-2xl md:text-4xl font-semibold text-center">
          How Businesses Use Bridge Format AIQ
        </h2>
      </div>

      {/* Cards */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {data.map((item, index) => (
          <div
            key={index}
            className="bg-gray-100 rounded-[4px] p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
          >
            <h3 className="text-lg md:text-xl font-bold mb-2">{item.title}</h3>

            <p className="text-sm md:text-base font-semibold mb-4">
              {item.highlight}
            </p>

            <ul className="space-y-2 text-sm md:text-base text-gray-600">
              {item.points.map((point, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="mt-1 w-1.5 h-1.5 bg-black rounded-full" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
